export default __webpack_public_path__ + "static/card-1b88253591f414f4be7a778535cb2ac9.jpg";